import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo a la noche sin saber qué hay para el lunes', 'Comprás en el almacén y gastás el doble', 'Tirás comida porque no sabés cómo usar lo que sobró', 'Pedís delivery cuando ya no aguantás más', 'Llegás a fin de mes sin entender cómo se fue el dinero', 'El próximo mes, el mismo ciclo'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-197">
      <div className="bg-navy-800/40 border border-navy-700 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-198">
        <h3 className="text-2xl font-bold text-white mb-8 border-b border-navy-700 pb-4 inline-block" data-id="element-199">
          Sin sistema
        </h3>

        <div className="space-y-6" data-id="element-200">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-201">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-202" />
              <p className="text-lg md:text-xl text-blue-100" data-id="element-203">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-204">
          <h3 className="text-2xl md:text-3xl font-bold text-gold-400" data-id="element-205">
            ¿Y si este fuera el último domingo que terminás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}